<template>
  <v-container v-if="estado">
    <v-form ref="formDatosProgramar" lazy-validation>
      <v-row>

        <v-col cols="2">
          <v-btn v-if="compParametroP.evento != 'editar'" icon color="primary" @click="returnBack">
            <v-icon>fas fa-angle-double-left</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="8" class="d-flex justify-center pb-2 pt-2">
          <v-alert dense outlined color="primary">
            <v-row>

              <v-col cols="12">
                <v-chip class="ma-2" label>
                  Unidad : {{ programarCl.nombre_tema }}
                </v-chip>
                -
                <v-chip class="ma-2" label>
                  Tema : {{ programarCl.nombre_clase }}
                </v-chip>
              </v-col>

            </v-row>
          </v-alert>
        </v-col>

        <v-col cols="12" v-if="compParametroP.evento != 'agregar'" class="d-flex justify-center">
          Estado actual :

          <v-chip small dark class="ml-2" label :color="programarCl.color_estado">
            {{ programarCl.desc_estado }} {{ compParametroP.evento }}
          </v-chip>

        </v-col>

        <v-col cols="12" md="3" v-if="compParametroP.evento == 'editar'">
          <v-card outlined>
            <v-card-text>
              <p>
                Estado
              </p>
              <v-radio-group v-model="programarCl.id_estado">
                <v-radio :label="`Actualizar`" :value="5" @change="eventActualizar" color="#ffbc00"></v-radio>
                <v-radio :label="`Reprogramar`" :value="2" @change="eventReprogramar" color="#ffbc00"></v-radio>
                <v-radio :label="`Sin ejecutar`" :value="3" @change="eventSinEjecutar" color="#e53935"></v-radio>
                <v-radio :label="`Ejecutada`" :value="4" @change="eventEjecutar" color="#6abf69"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" :md="compParametroP.evento == 'editar' ? 9 : 12">
          <v-card outlined>
            <v-card-text>
              <v-row>

                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp v-model="programarCl.id_nivel" :items="nivelDoc"
                    :isDisable="compParametroP.evento == 'editar' || compParametroP.evento == 'agregar'"
                    :item-value="'id_nivel'" item-text="desc_nivel" textLabel="Nivel"
                    :rules="validationRules.validateCampoList" />
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp v-model="programarCl.id_grado" :items="gradoDoc"
                    :isDisable="compParametroP.evento == 'editar' || compParametroP.evento == 'agregar'"
                    :item-value="'id_grado'" item-text="desc_grado" textLabel="Grado"
                    :rules="validationRules.validateCampoList" />
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp v-model="programarCl.id_area" :items="areaDoc"
                    :isDisable="compParametroP.evento == 'editar' || compParametroP.evento == 'agregar'"
                    :item-value="'id_area'" item-text="desc_area" textLabel="Área"
                    :rules="validationRules.validateCampo" />
                  <!-- Filter, id_area_dinamic -->
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp v-model="programarCl.id_curso" :items="cursoDoc"
                    :isDisable="compParametroP.evento == 'editar' || compParametroP.evento == 'agregar'"
                    :item-value="'id'" item-text="desc_curso" textLabel="Curso"
                    :rules="validationRules.validateCampoList" />
                  <!-- Filter, id_curso_dinamic -->
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp v-model="programarCl.id_seccion" :items="seccionDocFilter"
                    :isDisable="compParametroP.evento == 'editar'" item-value="id" item-text="nombre_seccion"
                    :textLabel="$t('titulo.seccion')" :rules="validationRules.validateCampoList"
                    @change="mandarSeccionProps" />
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="programarCl.fecha" label="Fecha" readonly v-on="on"
                        :rules="validationRules.validateCampo" :disabled="inhabilitarFecha">
                      </v-text-field>
                    </template>

                    <v-date-picker :disabled="disabledDatePicker" v-model="programarCl.fecha" no-title
                      @input="menu = false" :min="getEndDate" :allowed-dates="allowedDates"
                      @change="mandarFechaProp(1)"></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- horaInicioClase -->
                <v-col cols="12" md="4" class="py-0">
                  <AutocompleteComp textLabel="Horario de inicio" :items="horarioClaseDocente" v-model="horasClases"
                    item-text="hora_inicio" @change="escogerHorarioInicio($event)"
                    :isDisable="programarCl.id_estado == 3 || programarCl.id_estado == 4 || !programarCl.fecha ? true : false"
                    return-object :rules="validationRules.validateCampoList" />
                </v-col>
                <v-col cols="12" md="4" class="py-0">
                  <v-text-field label="Horario de finalización" v-model="programarCl.hora_fin" :disabled="true"
                    :rules="validationRules.validateCampoList">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <v-radio-group v-model="enlaceVirtualFlag" label="Grabar clase :" class="d-flex ma-0"
                    :disabled="inhabilitarClaseVirtual">
                    <v-radio label="Sí" :value="1" color="teal"></v-radio>
                    <v-radio label="No" :value="0" color="#005aff"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" class="py-0" v-if="enlaceVirtualFlag == 1">
                  <v-text-field type="text" v-model="programarCl.enlace_virtual"
                    label="Pegue aquí el enlace de la grabación" :disabled="inhabilitarEnlaceVirtual"
                    prepend-icon="fas fa-link" :required="programarCl.clase_virtual == 1"></v-text-field>
                </v-col>
                <!-- programarCl.clase_virtual_video == 1 && programarCl.id_estado == 4 -->
                <v-col cols="12" class="py-0" v-if="programarCl.clase_virtual_video == 1 && programarCl.id_estado == 4">
                  <v-text-field type="text" v-model="programarCl.clase_virtual_video_enlace"
                    label="Pegue aquí su enlace de video de clase grabada" :disabled="inhabilitarClaseVirtualEnlace"
                    prepend-icon="fas fa-link"></v-text-field>
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-textarea v-model="programarCl.observacion" label="Observación" :disabled="inhabilitarObservacion"
                    rows="2">
                  </v-textarea>
                </v-col>

                <v-col cols="12" class="d-flex justify-center">
                  <v-alert dense color="transparent">
                    <v-row>
                      <v-col cols="12">
                        <ButtonComp v-if="compParametroP.evento != 'editar'" @click="saveProgDocente"
                          textButton="Guardar" iconBut="fas fa-save" normalButton />
                        <ButtonComp v-else @click="editarProgramacion" textButton="Guardar cambios"
                          iconBut="fas fa-save" normalButton />
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>

        </v-col>

      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from "@/helpers/axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import AutocompleteComp from "../../../../../components/ComponentsEst/AutocompleteComp.vue";
import { validationRules } from "../../../../../helpers/validatorHelpers";
import ButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue';

export default {
  name: "formprogclase",
  props: ["estado", "compParametroP"],

  components: {
    AutocompleteComp,
    ButtonComp,
  },

  data: () => ({

    datoLogin: sessionStorage,
    programarCl: {},
    nivelDoc: [],
    gradoDoc: [],
    areaDoc: [],
    cursoDoc: [],
    seccionDoc: [],
    seccionDocFilter: [],
    inhabilitarFecha: true,
    inhabilitarHoraInicio: false,
    inhabilitarHoraFin: false,
    inhabilitarSesionAprendisaje: false,
    inhabilitarClaseVirtual: false,
    inhabilitarEnlaceVirtual: false,
    inhabilitarClaseVirtualEnlace: false,
    inhabilitarObservacion: false,
    disabledDatePicker: false,
    evento: null,
    menu: false,
    horarioClaseDocente: [],
    horasClases: {},
    horaInicioClase: "",
    horaFinClase: "",
    fechaProp: "",
    enlaceVirtualFlag: 0,
  }),

  mounted() {
    this.loadMain();

  },


  computed: {
    ...mapState({
      datosSesionAprendizaje: state => state.progDocente.datosSesionAprendizaje,
      horariosDiasDisponibles: state => state.progDocente.horariosDiasDisponibles,
    }),
    ...mapGetters("login", ["componenteEvento"]),
    validationRules() {
      return validationRules;
    },
    getEndDate() {
      return moment().format("YYYY-MM-DD");
    },
  },

  watch: {

    estado(valor) {
      if (valor) {
        this.loadMain();
      } else {
        this.limpiarForm();
      }
    },
    enlaceVirtualFlag(valor) {

      if (valor == 1) {
        this.programarCl.clase_virtual = valor;
      } else {
        this.programarCl.enlace_virtual = "";
      }
    }

  },

  methods: {
    ...mapActions({
      obtenerHorariosDocente: "progDocente/obtenerHorariosDocente"
    }),
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
      setSesionAprendizaje: "progDocente/setDataSesionAprendizaje"
    }),
    /** 
    _________________________________________________
   |          MÉTODO OBTENER PROGRAMACION          */
    loadMain() {

      this.programarCl = this.compParametroP;
      this.nivelDoc = this.compParametroP.nivelDoc;
      this.gradoDoc = this.compParametroP.gradoDoc;
      this.areaDoc = this.compParametroP.areaDoc;
      this.cursoDoc = this.compParametroP.cursoDoc;

      switch (this.compParametroP.evento) {

        case "agregar":

          this.addItem();

          break;

        case "editar":

          this.seccionDoc = this.compParametroP.seccionDoc;
          this.editItem();

          break;

      }

    },
    /** 
    ___________________________________________________________________
   |          MÉTODO PARA AGREGAR UNA PROGRAMACIÓN DE CLASE          */
    addItem() {
      this.limpiarForm();


      let datoSecciones = this.compParametroP.items.secciones;

      this.seccionDocFilter = datoSecciones.filter(
        (el) => el.seccion_programada === 0
      );

      this.programarCl.enlace_virtual = ""
      this.programarCl.nombre_tema = this.compParametroP.items.nombre_tema;
      this.programarCl.nombre_clase = this.compParametroP.items.nombre_clase;

      this.evento = "agregar";
      this.programarCl.tipo_contenido = this.compParametroP.tipo_contenido;
      this.programarCl.id_clase = this.compParametroP.items.id_clase;
      this.programarCl.sesion_aprendizaje = this.compParametroP.items.sesion;
      this.programarCl.clase_virtual_video = 0;
      this.programarCl.id_personal = this.compParametroP.id_personal;
      this.programarCl.clase_virtual = 0;
      this.programarCl.desc_estado = "Programada";
      this.programarCl.color_estado = "6d6d6d";
      this.programarCl.id_nivel = this.compParametroP.id_nivel;
      this.programarCl.id_grado = this.compParametroP.id_grado;
      this.programarCl.id_area = this.compParametroP.id_area;
      this.programarCl.id_curso = this.compParametroP.id_curso;

      this.enlaceVirtualFlag = 0;

    },

    /** 
    ___________________________________________________________________
   |          MÉTODO PARA EDITAR UNA PROGRAMACIÓN DE CLASE          */
    editItem() {

      this.seccionDocFilter = this.seccionDoc.map((items) => {
        return { ...items, id: items.id_seccion, nombre_seccion: items.desc_seccion }
      });

      this.programarCl.id = this.compParametroP.items.id;
      this.programarCl.nombre_tema = this.compParametroP.items.nombre_tema;
      this.programarCl.nombre_clase = this.compParametroP.items.nombre_clase;
      this.programarCl.tipo_contenido = this.compParametroP.items.tipo_contenido;
      this.programarCl.desc_estado = this.compParametroP.items.desc_estado;
      this.programarCl.color_estado = this.compParametroP.items.color_estado;
      this.programarCl.id_nivel = this.compParametroP.items.id_nivel;
      this.programarCl.id_grado = this.compParametroP.items.id_grado;
      this.programarCl.id_area = this.compParametroP.items.id_area;
      this.programarCl.id_curso = this.compParametroP.items.id_curso;
      this.programarCl.id_seccion = this.compParametroP.items.id_seccion;
      this.programarCl.fecha = this.compParametroP.items.fecha;
      this.programarCl.observacion = this.compParametroP.items.observacion;
      this.programarCl.id_personal = this.compParametroP.items.id_profesor;
      this.programarCl.enlace_virtual = this.compParametroP.items.enlace_virtual;
      this.programarCl.clase_virtual = this.compParametroP.items.clase_virtual;
      this.enlaceVirtualFlag = this.compParametroP.items.clase_virtual;

      this.mandarFechaProp(1);
      this.horasClases.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_fin = this.compParametroP.items.hora_fin;
      this.programarCl.id_estado = 5;
      this.programarCl.sesion_aprendizaje = this.compParametroP.items.sesion_aprendizaje;
      this.programarCl.id_clase = this.compParametroP.items.id_clase;
      this.programarCl.clase_virtual_video = this.compParametroP.items.clase_virtual_video;
      this.programarCl.clase_virtual_video_enlace = this.compParametroP.items.clase_virtual_video_enlace;

      this.bloquearCampos();

    },
    /** 
    _________________________________________________
   |          MÉTODO OBTENER PROGRAMACION          */
    async mandarSeccionProps() {

      this.$emit('listener', 'setidSeccion', this.programarCl.id_seccion);

      await this.obtenerHorariosDocente({
        id_personal: this.programarCl.id_personal,
        id_seccion: this.programarCl.id_seccion,
        id_curso: this.programarCl.id_curso
      })

      this.disabledDatePicker = false;

      this.inhabilitarFecha = false;

    },
    /** 
    __________________________________________________
   |          MÉTODO MANDAR PROPS SECCION           */
    mandarFechaProp(accion) {

      this.horasClases = {};
      this.programarCl.hora_fin = "";

      let selectedDate = new Date(this.programarCl.fecha);
      let dayOfWeek = selectedDate.getUTCDay(); // Fecha Actual


      //metodo que iguala la fecha al dia de la semana en la tabla (ck1_adm_horarios_dias)
      let dia_semana;
      switch (dayOfWeek) {
        case 1: // Lunes
          dia_semana = 1;
          break;
        case 2: // Martes
          dia_semana = 5;
          break;
        case 3: // Miércoles
          dia_semana = 6;
          break;
        case 4: // Jueves
          dia_semana = 7;
          break;
        case 5: // Viernes
          dia_semana = 8;
          break;
        case 6: // Sábado
          dia_semana = 9;
          break;
        case 7: // Domingo
          dia_semana = 10;
          break;
        default:
          dia_semana = null;
          break;
      }

      this.programarCl.id_ano_lectivo = this.datoLogin.id_ano_lectivo;

      const dataApiHorario = {
        id_dia: dia_semana,
        id_ano_lectivo: this.programarCl.id_ano_lectivo,
        id_seccion: this.programarCl.id_seccion,
        id_area: this.programarCl.id_area,
        id_curso: this.programarCl.id_curso,
        id_personal: this.programarCl.id_personal,
      }

      this.getTeacherSchedule(dataApiHorario, accion);
      this.$emit('listener', 'setFecha', this.programarCl.fecha);

    },
    /** 
    ________________________________________________________
   |          MÉTODO OBTENER HORARIO DEL DOCENTE          */
    async getTeacherSchedule(data, accion) {

      try {
        const response = await axios.post('/academico/progDocente/getTeacherSchedule', { data });

        if (!response.data[0]) {
          this.setEnviarMens({
            tipo: 'W',
            mensaje: 'El Administrador no le ha asignado un horario para este día.',
            tiempo: null,
          });
          this.horarioClaseDocente = []
        } else {

          this.setEnviarMens({
            tipo: accion == 1 ? 'S' : 'W',
            mensaje: accion == 1 ? 'Selecciona una hora de su clase.' : 'Por favor seleccione una hora mayor a la actual o cambie de fecha.',
            tiempo: 2000,
          });

          this.horarioClaseDocente = response.data;
        }

      } catch (error) {

        console.log("Error al intentar traerte el horario del docente " + error)
      }
    },
    /** 
    ____________________________________________
   |          MÉTODO DIAS PERMITIDOS          */
    allowedDates(val) {
      const dateParts = val.split('-');
      const selectedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      const dayOfWeek = selectedDate.getDay();

      console.log({ dayOfWeek });

      return this.horariosDiasDisponibles.includes(dayOfWeek);
    },

    /** 
    ____________________________________________
   |          MÉTODO OBTENER HORARIO          */
    escogerHorarioInicio(items) {

      let selectedDate = new Date(this.programarCl.fecha).toISOString().substr(0, 10);
      const today = new Date();
      // Crear un objeto `Intl.DateTimeFormat` con la configuración de la zona horaria de Perú
      const formatter = new Intl.DateTimeFormat('es-PE', {
        timeZone: 'America/Lima',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      // Usar el formateador para obtener la fecha ajustada a la zona horaria de Perú
      const [{ value: day }, , { value: month }, , { value: year }] = formatter.formatToParts(today);
      const localDateInPeru = `${year}-${month}-${day}`;

      if (selectedDate > localDateInPeru) {

        this.programarCl.hora_inicio = items.hora_inicio;
        this.programarCl.hora_fin = items.hora_fin;

      } else if (selectedDate == localDateInPeru) {

        const horaActualStr = [today.getHours(), today.getMinutes(), today.getSeconds()].map(num => num.toString().padStart(2, '0')).join(':');
        const horaEspecifica = items.hora_inicio;

        if (horaEspecifica < horaActualStr) {

          if (this.horarioClaseDocente.length == 1) {
            this.programarCl.fecha = null
          }
          // this.horasClases.hora_inicio = null; 
          this.programarCl.hora_inicio = '';
          this.programarCl.hora_fin = '';

          this.mandarFechaProp(0);


        } else if (horaEspecifica > horaActualStr) {
          this.programarCl.hora_inicio = items.hora_inicio;
          this.programarCl.hora_fin = items.hora_fin;
        } else {
          console.log("La hora específica es igual a la hora actual.");
          this.programarCl.hora_inicio = '';
          this.programarCl.hora_fin = '';
        }

      } else {
        console.log('no seleccionable');
      }

    },
    /** 
    _________________________________________________
   |          MÉTODO OBTENER PROGRAMACION          */
    limpiarForm() {
      this.horasClases = null;
      this.horarioClaseDocente = [];
      this.programarCl = {};
    },
    /** 
    ____________________________________________
   |          MÉTODO BLOQUEAR CAMPOS          */
    bloquearCampos() {
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;
    },
    /** 
    _______________________________________________________
   |          MÉTODO EDITAR PROGRAMACION CLASE           */
    async editarProgramacion() {

      if (this.$refs.formDatosProgramar.validate()) {

        let dataProgClase = {
          usuario: parseInt(this.datoLogin.id),
          fecha: this.programarCl.fecha,
          hora_inicio: this.programarCl.hora_inicio,
          hora_fin: this.programarCl.hora_fin,
          clase_virtual: this.programarCl.clase_virtual,
          enlace_virtual: this.programarCl.enlace_virtual,
          clase_virtual_video: this.programarCl.clase_virtual_video,
          clase_virtual_video_enlace: this.programarCl.clase_virtual_video_enlace,
          observacion: this.programarCl.observacion,
          id_estado: this.programarCl.id_estado
        };

        // console.log({dataProgClase});
        this.savenotif();
        try {

          const response = await axios.put(
            "/academico/progDocente/" + this.programarCl.id,
            dataProgClase
          );


          this.setEnviarMens({ tipo: response.data.messageT, mensaje: response.data.message, tiempo: null });

          if (response.data.messageT == "S") {
            this.$emit('close')
          }

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },
    /** 
    _________________________________________________
   |          MÉTODO GUARDAR PROGRAMACION          */
    async saveProgDocente() {

      if (!this.$refs.formDatosProgramar.validate()) return;

      let dataProgClase = {
        id_ano_lectivo: this.programarCl.id_ano_lectivo,
        id_colegio: this.datoLogin.id_colegio,
        id_nivel: this.programarCl.id_nivel,
        id_grado: this.programarCl.id_grado,
        id_area: this.programarCl.id_area,
        id_curso: this.programarCl.id_curso,
        id_seccion: this.programarCl.id_seccion,
        id_profesor: this.programarCl.id_personal,
        id_clase: this.programarCl.id_clase,
        tipo_contenido: this.programarCl.tipo_contenido,
        fecha: this.programarCl.fecha,
        hora_inicio: this.programarCl.hora_inicio,
        hora_fin: this.programarCl.hora_fin,
        enlace_virtual: this.programarCl.enlace_virtual,
        clase_virtual: this.programarCl.clase_virtual,
        clase_virtual_video: this.programarCl.clase_virtual_video,
        observacion: this.programarCl.observacion,
        id_us_ing: parseInt(this.datoLogin.id)
      };
      
      const totalData = {
        informacionProgClase: dataProgClase,
        informacionSesion: this.datosSesionAprendizaje
      }      

      try {

        if (totalData.informacionSesion.indicadores.length > 0) {    
          this.savenotif();      
          const response = await axios.post("/academico/progDocente/SP_addupdateProgDocente", totalData);
          this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
        }else{
          this.setEnviarMens({ tipo: "W", mensaje: `Clase no tiene indicadores por favor, agregarlos`, tiempo: null });
        }

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });

      } finally {
        this.returnBack();
      }

    },

    async savenotif() {
      let titulo = ''
      let contenido = ''
      switch (this.programarCl.id_estado) {
        case 5:
          titulo = 'Clase actualizada';
          contenido = 'Los detalles de la clase fueron actualizados'
          break;
        case 2:
          titulo = 'Clase reprogramada';
          contenido = 'La clase fue reprogramada'
          break;
        case 3:
          titulo = 'Clase sin ejecutar';
          contenido = 'Se cambio el estado de la clase a sin ejecutar'
          break;
        case 4:
          titulo = 'Clase Ejecutada';
          contenido = 'Se cambio el estado de la clase a ejecutada'
          break
        default:
          titulo = 'Clase programada';
          contenido = 'Tienes una nueva clase programada'
          break;
      }
      const fechaActual = new Date();
      const horaActual = fechaActual.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const datanotif = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        titulo_notif: titulo,
        contenido_notif: contenido,
        id_perfil: this.datoLogin.id_perfil,
        id_usuario: this.datoLogin.id,
        fecha_notif: fechaActual,
        hora_notif: horaActual,
        id_seccion: this.programarCl.id_seccion,
        id_curso: this.programarCl.id_curso,
        tema_clase: this.programarCl.nombre_clase,
        icon_notif: 'fas fa-users'
      };
      try {
        const response1 = await axios.post("/notification/persona/addnotif/", datanotif);
        this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
    ________________________________________________________
   |          MÉTODO RETORNAR SELECCIONAR CLASE           */
    returnBack() {

      this.setSesionAprendizaje({});
      this.$refs.formDatosProgramar.resetValidation();
      this.$emit('listener', 'returnBack', null);

    },

    /** 
    ________________________________________________________
   |          MÉTODO ACTUALIZAR ESTADO DE CLASE           */
    eventActualizar() {
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;
      this.programarCl.clase_virtual_video = 0;
      this.programarCl.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_fin = this.compParametroP.items.hora_fin;
    },
    /** 
    _______________________________________________
   |          MÉTODO REPROGRAMAR CLASE           */
    eventReprogramar() {
      this.inhabilitarFecha = false;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;
      this.programarCl.clase_virtual_video = 0;
      this.programarCl.clase_virtual_video_enlace = "";
      this.programarCl.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_fin = this.compParametroP.items.hora_fin;
    },
    /** 
    __________________________________________________________
   |          MÉTODO SIN EJECUTAR ESTADO DE CLASE           */
    eventSinEjecutar() {
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = true;
      this.inhabilitarHoraFin = true;
      this.inhabilitarSesionAprendisaje = true;
      this.inhabilitarClaseVirtual = true;
      this.inhabilitarEnlaceVirtual = true;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;
      this.programarCl.clase_virtual_video = 0;
      this.programarCl.clase_virtual_video_enlace = "";
      this.programarCl.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_fin = this.compParametroP.items.hora_fin;
    },
    /** 
    ________________________________________________________
   |          MÉTODO EJECUTAR ESTADO DE CLASE           */
    async eventEjecutar() {
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = true;
      this.inhabilitarHoraFin = true;
      this.inhabilitarSesionAprendisaje = true;
      this.inhabilitarClaseVirtual = true;
      this.inhabilitarEnlaceVirtual = true;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;
      this.programarCl.clase_virtual_video = 1;
      this.programarCl.hora_inicio = this.compParametroP.items.hora_inicio;
      this.programarCl.hora_fin = this.compParametroP.items.hora_fin;
    },
  },
};
</script>